import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

const setStrokeColor = props => {
  if (props.isWrapped) {
    return "currentColor";
  }

  return colors[props.strokeColor];
};

const BedroomsWrapper = styled.svg`
  padding: ${props => props.desktopPadding};

  @media screen and (max-width: 660px) {
    padding: ${props => props.mobilePadding};
  }
`;

const BedroomsOutline = styled.g`
  stroke: ${props => setStrokeColor(props)};
`;

const IconWrapper = styled.span`
  box-sizing: border-box;
  display: inline-block;
  line-height: 0;
  padding: ${props => props.desktopPadding};

  @media screen and (max-width: 660px) {
    padding: ${props => props.mobilePadding};
  }

  * {
    box-sizing: border-box;
  }
`;

export { BedroomsOutline, BedroomsWrapper, IconWrapper };
